export interface RankingWidgetParams {
  market: string;
  year: string;
  ranking: string;
  criteria: string;
  timeRange: string;
}

export function isPlatformRankingUrl(url?: string | null) {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    const isUqbarDomain =
      parsed.hostname.includes('uqbar.com.br') ||
      !!process?.env?.REACT_APP_PUBLIC_URL?.includes(parsed.hostname);
    const isRankingPath = parsed.pathname === '/rankings/dados';

    return isUqbarDomain && isRankingPath;
  } catch (_) {
    return false;
  }
}

export function isMetabaseRankingUrl(url?: string | null) {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return parsed.hostname.includes('metabase.uqbaronline.com');
  } catch (_) {
    return false;
  }
}

export function extractRankingParams(
  url?: string | null,
): RankingWidgetParams | null {
  if (!url || !isPlatformRankingUrl(url)) {
    return null;
  }

  try {
    const parsed = new URL(url);

    const market = parsed.searchParams.get('market');
    const year = parsed.searchParams.get('year');
    const ranking = parsed.searchParams.get('ranking');
    const criteria = parsed.searchParams.get('criteria');
    const timeRange = parsed.searchParams.get('timeRange');

    if (!market || !year || !ranking || !criteria || !timeRange) {
      return null;
    }

    return {
      market,
      year,
      ranking,
      criteria,
      timeRange,
    };
  } catch (_) {
    return null;
  }
}
